import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { v4 as uuidv4 } from "uuid";

import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Delete from "@material-ui/icons/Delete";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

import {
  deletePhotoFromGoogleCloudStorage,
  uploadPhotoGoogleCloudStorage,
} from "../../../apis/photoAction";
import { userLogging } from "../../../apis/userLog";
import { updateTenpoCheckPhoroUrl } from "../../../features/tenpoStatusSlice";
import { selectImageToken } from "../../../features/userSlice";
import { getFixedFlg } from "../../Header/Header";
import PhotoEdit from "../../organisms/photo/PhotoEdit";
import SwitchTextArea, { HandwriteUpdate } from "../../organisms/text/SwitchTextArea";
import TenpoCheckDialog from "../TenpoCheckDialog";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    uploadGrid: {
      height: "9vh",
    },
    noUpload: {
      color: "#f2f2f2",
    },
    uploaded: {
      color: "#37ab9d",
    },
    modalPane: {
      position: "absolute",
      paddingTop: "2%",
      paddingLeft: "5%",
      width: "84%",
      height: "80%",
    },
    paper: {
      height: "100%",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    titleGrid: {
      height: "7vh",
      color: "white",
      backgroundColor: "#4dc0b2",
    },
    titleTypography: {
      fontWeight: "bold",
    },
    textCommentArea: {
      width: "220px",
      // iPad縦
      "@media (min-width: 830px)": {
        width: "200px",
      },
      // iPad横
      "@media (min-width: 1100px)": {
        width: "200px",
      },
      // GWPC
      "@media (min-width: 1200px)": {
        width: "220px",
      },
    },
  })
);

// 文字列のサイズ幅算出（半角文字0.5,全角文字1として計算）
function countText(comment: any) {
  let count = 0;
  for (let i = 0; i < comment.length; i++) {
    let c = comment.charCodeAt(i);
    if (
      (c >= 0x0 && c < 0x81) ||
      c === 0xf8f0 ||
      (c >= 0xff61 && c < 0xffa0) ||
      (c >= 0xf8f1 && c < 0xf8f4)
    ) {
      count += 0.5;
    } else {
      count += 1;
    }
  }
  return count;
}

const TenpoCheckModalButton: FC<{
  title: string;
  comment?: string;
  photoFilePath: string[];
  photoFileSize: number[];
  commentFilepath: string[],
  commentFilesize: number[],
  commentHandwrite: string;
  qualityLevel: string;
  templateFlag?: number;

  onClickSave?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    comment: string,
    photoFilePath: string[],
    photoFileSize: number[],
    commentFilepathGcs: string[],
    commentFilesizeGcs: number[],
    commentHandwriteFlag: string,
    qualityLevel: string,
    templateFlag: number
  ) => void;
  tenpoCode?: string;
  isTemplate?: boolean;
}> = ({ title, comment, photoFilePath, photoFileSize, commentFilepath, commentFilesize, commentHandwrite, qualityLevel: ql, templateFlag, onClickSave, tenpoCode, isTemplate = false }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [modalComment, setModalComment] = React.useState(comment);
  const [initComment, setInitComment] = React.useState(comment);
  const [initialCommentOnOpen, setInitialCommentOnOpen] = React.useState<string | undefined>(undefined);
  const [initFiles, setInitFiles] = React.useState<{ path: string, size: number }[]>([]);
  const [initialFilesOnOpen, setInitialFilesOnOpen] = React.useState<{ path: string, size: number }[]>([]);
  const [initialPhotoPath, setInitialPhotoPath] = React.useState<string | null>(null);
  const [files, setFiles] = React.useState<{ path: string, size: number }[]>([]);
  const [totalImageSize, setTotalImageSize] = React.useState(0);
  const [filesToDelete, setFilesToDelete] = React.useState<{ path: string, size: number }[]>([]);
  const [newlyUploadedFiles, setNewlyUploadedFiles] = React.useState<{ path: string, size: number }[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [commentFilepathGcs, setCommentFilepathGcs] = React.useState<string[]>(commentFilepath);
  const [commentFilesizeGcs, setCommentFilesizeGcs] = React.useState<number[]>(commentFilesize);
  const [commentHandwriteFlag, setCommentHandwriteFlag] = React.useState<string>(commentHandwrite);
  const [initCommentFilepathGcs, setInitCommentFilepathGcs] = React.useState<string[]>(commentFilepath);
  const [initCommentFilesizeGcs, setInitCommentFilesizeGcs] = React.useState<number[]>(commentFilesize);
  const [initCommentHandwriteFlag, setInitCommentHandwriteFlag] = React.useState<string>(commentHandwrite);
  const [handwriteUpdateClass, setHandwriteUpdateClass] = React.useState<string>(HandwriteUpdate.Non);
  const [canvasContext, setCanvasContext] = React.useState<CanvasRenderingContext2D | null>(null);
  const [qualityLevel, setQualityLevel] = React.useState(ql || "low");
  const [localTemplateFlag, setLocalTemplateFlag] = React.useState(isTemplate ? 1 : templateFlag || 0);
  const [isImageModified, setIsImageModified] = React.useState(false);

  // useEffect(() => {
  //   if (open) {
  //     const newFlag = isTemplate ? 1 : templateFlag || 0;
  //     setLocalTemplateFlag(newFlag);
  //   }
  // }, [open, templateFlag, isTemplate]);

  const dialogClose = () => {
    setDialogFlg(false);
  };
  const handleOpen = () => {
    setFilesToDelete([]);
    setNewlyUploadedFiles([]);
    setOpen(true);
    setIsImageModified(false);
    setInitialCommentOnOpen(comment);

    const initialFiles = photoFilePath.map((path, index) => ({
      path,
      size: photoFileSize?.[index] || 0,
    }));
    setInitialFilesOnOpen(initialFiles);

    // 初期画像のサイズを計算
    const initialSize = files ? files.reduce((acc, file) => acc + (file.size || 0), 0) : 0;
    setTotalImageSize(initialSize);
  };

  useEffect(() => {
    setCommentFilepathGcs(commentFilepath);
    setCommentFilesizeGcs(commentFilesize);
    setCommentHandwriteFlag(commentHandwrite);
  }, [commentFilepath, commentFilesize, commentHandwrite]);

  useEffect(() => {
    if (open) setHandwriteUpdateClass(HandwriteUpdate.Non);
  }, [open]);

  useEffect(() => {
    const initialFiles = photoFilePath.map((path, index) => ({
      path,
      size: photoFileSize && photoFileSize[index] ? photoFileSize[index] : 0,
    }));
    setFiles(initialFiles);
    setInitFiles(initialFiles);
    const initialSize = initialFiles.reduce((acc, file) => acc + (file.size || 0), 0);
    setTotalImageSize(initialSize);
  }, [photoFilePath, photoFileSize, open]);

  useEffect(() => {
    if (open) {
      setQualityLevel(ql || "low");
      setInitialPhotoPath(photoFilePath && photoFilePath.length > 0 ? photoFilePath[0] : null);
    }
  }, [ql, open, photoFilePath]);

  const handleSave = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (getFixedFlg()) {
      setOpen(false);
      return;
    }
    setLoading(true);

    let loCommentFilepathGcs: string[] = [];
    let loCommentFilesizeGcs: number[] = [];
    if (commentHandwriteFlag === "1") {
      if (handwriteUpdateClass === HandwriteUpdate.Update) {
        const filePath = "tenpo-check-comment/";
        const fileName = tenpoCode + "-" + uuidv4();
        const newFile = await uploadHandwrite(filePath, fileName);
        loCommentFilepathGcs = newFile.path;
        loCommentFilesizeGcs = newFile.size;
      } else if (handwriteUpdateClass === HandwriteUpdate.Delete) {
        loCommentFilepathGcs = [];
        loCommentFilesizeGcs = [];
      } else {
        loCommentFilepathGcs = commentFilepathGcs || [];
        loCommentFilesizeGcs = commentFilesizeGcs || [];
      }
    }

    let loComment = modalComment || "";
    const loFilePath = files ? files.map(f => f.path) : [];
    const loFileSize = files ? files.map(f => f.size || 0) : [];
    const loCommentHandwriteFlag = commentHandwriteFlag || "";

    setFiles(files);
    setInitFiles(files);
    setInitComment(loComment);
    setCommentFilepathGcs(loCommentFilepathGcs);
    setCommentFilesizeGcs(loCommentFilesizeGcs);
    setInitCommentFilepathGcs(loCommentFilepathGcs);
    setInitCommentFilesizeGcs(loCommentFilesizeGcs);
    setInitCommentHandwriteFlag(loCommentHandwriteFlag);

    if (onClickSave) {
      const finalTemplateFlag = (localTemplateFlag === 1 && !isImageModified) ? 1 : 0;
      onClickSave(e, loComment, loFilePath, loFileSize, loCommentFilepathGcs, loCommentFilesizeGcs, loCommentHandwriteFlag, qualityLevel, finalTemplateFlag);
    }

    // 不要なファイルを削除
    if (filesToDelete.length > 0) {
      filesToDelete.forEach(async (file) => {
        if (file && file.path) {
          await deletePhotoFromGoogleCloudStorage(file.path);
        }
      });
    }
    setLoading(false);
    setOpen(false);
  };
  const handleClose = () => {
    if (loading) {
      return;
    }
    // このセッションでアップロードされたが保存されなかったファイルを削除
    if (newlyUploadedFiles.length > 0) {
      newlyUploadedFiles.forEach(async (file) => {
        if (file && file.path) {
          await deletePhotoFromGoogleCloudStorage(file.path);
        }
      });
    }

    setModalComment(initComment);
    setFiles(initFiles);
    setCommentFilepathGcs(initCommentFilepathGcs);
    setCommentFilesizeGcs(initCommentFilesizeGcs);
    setCommentHandwriteFlag(initCommentHandwriteFlag);
    setOpen(false);
  };

  // 引き渡し用canvas更新関数
  const updateCavasContext = (context: CanvasRenderingContext2D): void => {
    setCanvasContext(context);
  }

  // 引き渡し用コメント手書きフラグ更新関数
  const updateCommentHandwriteFlag = (val: string): void => {
    setCommentHandwriteFlag(val);
  }

  // 引き渡し用手書きコメント変更有無
  const updateHandwriteUpdateClass = (val: string): void => {
    setHandwriteUpdateClass(val);
  }

  // 手書き画像アップロード
  const uploadHandwrite = (
    functionFilePath: string,
    fileName: string
  ): Promise<{ path: string[]; size: number[] }> => {
    return new Promise((resolve, reject) => {
      if (!canvasContext) {
        resolve({ path: [], size: [] });
        return;
      }
      const canvas: HTMLCanvasElement = canvasContext.canvas;
      canvas.toBlob(async (blob) => {
        if (!blob) {
          resolve({ path: [], size: [] });
          return;
        }
        const file = new File([blob], fileName);
        let dummyEvent = { target: { files: [file] } };
        // ファイルアップロード
        const result = await uploadPhotoGoogleCloudStorage(
          dummyEvent,
          functionFilePath,
          fileName
        );
        let newFile: { path: string[]; size: number[] } = { path: [], size: [] };
        if (!result || !result.downloadURL) {
          if (result.downloadURL === "") {
            setDialogMessage(["画像のアップロードに失敗しました"]);
            setDialogFlg(true);
          }
          resolve(newFile);
        } else {
          newFile = {
            path: [String(functionFilePath + fileName)],
            size: [result.fileSize],
          };
          resolve(newFile);
        }
      });
    });
  };
  
  const changeComment = (event: React.ChangeEvent<{ value: unknown }>) => {
    if (getFixedFlg()) return;
    let comment = event.target.value as string;
    if (comment && Number(comment.length) > 2000) {
      comment = comment.substring(0, 2000);
    }
    setModalComment(comment);
  };
  const processUploadPhoto = async (e: any, quality: string) => {
    // 既存のファイルを削除リストに追加
    if (files && files.length > 0 && files[0] && files[0].path) {
      const currentFile = files[0];
      
      // 合計サイズからは、差し替え前の画像のサイズを常に減算する
      setTotalImageSize(prev => prev - (currentFile.size || 0));

      // 実際にファイルを削除リストに入れるかどうかは、条件に応じて判断する
      const isNewlyUploaded = newlyUploadedFiles.some(f => f.path === currentFile.path);
      const fileName = currentFile.path.split('/').pop() || '';
      const isTenpoCodeMatch = tenpoCode ? fileName.startsWith(tenpoCode) : false;
      if ((localTemplateFlag === 0 || isNewlyUploaded) && isTenpoCodeMatch) {
        setFilesToDelete(prev => [...prev, currentFile]);
      }
    }
    // 画像が更新されたのでflagを更新
    setIsImageModified(true);

    const fileName = tenpoCode + "-" + uuidv4();
    const result = await uploadPhotoGoogleCloudStorage(
      e,
      "tenpo-check-photo/",
      fileName,
      quality
    );

    let resultUrl = null;
    if (!result || !result.downloadURL) {
      if (result.downloadURL === "") {
        setDialogMessage(["画像のアップロードに失敗しました"]);
        setDialogFlg(true);
      }
    } else {
      resultUrl = result.downloadURL;
      const newFile = {
        path: "tenpo-check-photo/" + fileName,
        size: result.fileSize,
      };
      setFiles([newFile]);
      setNewlyUploadedFiles([...newlyUploadedFiles, newFile]);
      setTotalImageSize(prev => prev + result.fileSize);
    }
    return [resultUrl, fileName];
  };

  const handleUploadPhoto = (e: any, quality: string) => {
    setLoading(true);
    if (getFixedFlg()) return;
    processUploadPhoto(e, quality).then((res) => {
      dispatch(
        updateTenpoCheckPhoroUrl({
          tenpoCheckPhoroUrl: res[0],
        })
      );
      setLoading(false);
    });
  };
  const imageToken = useSelector(selectImageToken);
  const loadingGif = `${window.location.origin}/image/icon_loader.gif`;
  function formatBytes(bytes: number, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
    const k = 1000;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
  function getImageFile(imagePath: string) {
    if (imagePath === undefined || imagePath === "") {
      return `${window.location.origin}/image/noimage.png`;
    }
    return (
      process.env.REACT_APP_CLOUD_STORAGE_URL +
      imagePath +
      "?access_token=" +
      imageToken
    );
  }
  function isUploaded(argFilePath: string, argComment: any, argCommentFilepath: string[]): any {
    if (
      (argFilePath && argFilePath !== "") ||
      (argComment && argComment !== "") ||
      (argCommentFilepath && argCommentFilepath[0] && argCommentFilepath[0] !== "")
    ) {
      return classes.uploaded;
    }
    return classes.noUpload;
  }

  function deleteFile(file: {path: string, size: number}) {
    userLogging("店舗確認表", "チェック#写真削除", file.path);
    if (file && file.path) {
      // テンプレートの有無に関わらず、合計サイズからは常に減算する
      setTotalImageSize(prev => prev - (file.size || 0));
      
      // テンプレートでない画像のみ、実際に削除するリストに追加する
      const fileName = file.path.split('/').pop() || '';
      const isTenpoCodeMatch = tenpoCode ? fileName.startsWith(tenpoCode) : false;
      if (localTemplateFlag === 0 && isTenpoCodeMatch) {
        setFilesToDelete(prev => [...prev, file]);
      }
    }
    // 画像が更新されたのでflagを更新
    setIsImageModified(true);
    setFiles([]);
  }

  // 画像編集での画像ファイルパス設定用関数
  const updateFilePath = (newFile: { path: string, size: number }): void => {
    // 編集前のファイルを削除リストに追加
    if (files && files.length > 0 && files[0] && files[0].path) {
      const currentFile = files[0];

      // 合計サイズからは、差し替え前の画像のサイズを常に減算する
      setTotalImageSize(prev => prev - (currentFile.size || 0));
      
      // 実際にファイルを削除リストに入れるかどうかは、条件に応じて判断する
      const isNewlyUploaded = newlyUploadedFiles.some(f => f.path === currentFile.path);
      const fileName = currentFile.path.split('/').pop() || '';
      const isTenpoCodeMatch = tenpoCode ? fileName.startsWith(tenpoCode) : false;
      if ((localTemplateFlag === 0 || isNewlyUploaded) && isTenpoCodeMatch) {
        setFilesToDelete(prev => [...prev, currentFile]);
      }
    }
    // 画像が更新されたのでflagを更新
    setIsImageModified(true);
    // 編集後のファイルを新規アップロードリストに追加
    if (newFile && newFile.path) {
      setNewlyUploadedFiles([...newlyUploadedFiles, newFile]);
      setTotalImageSize(prev => prev + (newFile.size || 0));
    }
    setFiles(newFile.path ? [newFile] : []);
  };

  // ファイル名作成関数
  const fileNameGenerator = (): string => { return (tenpoCode + "-" + uuidv4()) };

  return (
    <>
      {/*  カメラボタンここから↓*/}
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.uploadGrid}
      >
        <IconButton
          component="span"
          onClick={handleOpen}
          className={isUploaded(files.length > 0 ? files[0].path : "", modalComment, commentFilepathGcs)}
        >
          <PhotoCamera fontSize="large" />
        </IconButton>
      </Grid>
      {/*  カメラボタンここまで↑*/}
      {/*  モーダルここから↓*/}
      <Modal
        open={open}
        onClose={(event, reason) => {
          if (loading && reason === "backdropClick") {
            return;
          }
          handleClose();
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modalPane}
      >
        <Grid container className={classes.paper} style={{ overflowY: "auto" }}>
          {/*  タイトルここから↓*/}
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.titleGrid}
          >
            <Typography variant="h6" className={classes.titleTypography}>
              {title}
            </Typography>
          </Grid>
          {/*  タイトルここまで↑*/}
          <Grid
            container
            style={{
              marginBottom: "5px",
              display: "flex",
              alignSelf: "flex-start",
            }}
          >
            {/*  写真をアップロードここから↓*/}
            <Grid item lg={3} md={4} sm={5}>
              <Grid container justify="center" style={{ paddingTop: "10px" }}>
                {loading ? (
                  <img
                    alt=""
                    src={loadingGif}
                    style={{
                      paddingTop: "5px",
                      position: "absolute",
                    }}
                  />
                ) : (
                  ""
                )}
                <img
                  alt=""
                  src={getImageFile(files.length > 0 ? files[0].path : "")}
                  height="200"
                  style={{
                    width: "200px",
                    WebkitAppearance: "none",
                  }}
                />
              </Grid>
              <Grid container direction="column" alignItems="center" style={{ paddingTop: "10px" }}>
                <Grid container direction="row" justify="center" alignItems="center">
                  <label htmlFor="upload-photo">
                    <input
                      style={{ display: "none" }}
                      id="upload-photo"
                      name="upload-photo-name"
                      type="file"
                      onChange={(e) => {
                        handleUploadPhoto(e, qualityLevel);
                        e.target.value = "";
                      }}
                      disabled={getFixedFlg()}
                    />
                    {getFixedFlg() ? (
                      ""
                    ) : (
                      <>
                        <Button variant="contained" component="span">
                          写真をアップロード
                        </Button>
                      </>
                    )}
                  </label>
                  {!getFixedFlg() && files.length > 0 && files[0].path ? (
                    <>
                      <IconButton
                        onClick={(e) => {
                          deleteFile(files[0]);
                        }}
                        size={"small"}
                        style={{ marginLeft: "8px" }}
                      >
                        <Delete fontSize={"default"} />
                      </IconButton>

                      <PhotoEdit
                        baseFile={files[0]}
                        updateFile={updateFilePath}
                        fileNameGenerator={fileNameGenerator}
                        functionPath="tenpo-check-photo/"
                        updateLoading={setLoading}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
                <FormControl component="fieldset">
                  <RadioGroup row aria-label="quality" name="quality" value={qualityLevel} onChange={(e) => setQualityLevel(e.target.value)}>
                    <FormControlLabel value="low" control={<Radio />} label="通常画質" disabled={getFixedFlg() || loading} />
                    <FormControlLabel value="high" control={<Radio />} label="高画質" disabled={getFixedFlg() || loading} />
                  </RadioGroup>
                </FormControl>
                    <Typography variant="caption" style={{ textAlign: "center", display: "block" }}>
                      ※アップロード後は画質を変更できません。 <br/>
                      変更する場合は再度、画質を選択し画像をアップロードしてください。
                    </Typography>
              </Grid>
            </Grid>
            {/*  写真をアップロードここまで↑*/}
            {/*  その他コメントここから↓*/}
            <Grid item lg={9} md={8} sm={7} style={{ height: "45vh" }}>
              <Grid container justify="center">
                <Grid item>
                  <SwitchTextArea
                    comment={modalComment}
                    commentFilepathGcs={commentFilepathGcs}
                    commentHandwriteFlag={commentHandwriteFlag}
                    changeComment={changeComment}
                    updateCavasContext={updateCavasContext}
                    updateCommentHandwriteFlag={updateCommentHandwriteFlag}
                    updateHandwriteUpdateClass={updateHandwriteUpdateClass}
                  >
                  </SwitchTextArea>
                </Grid>
                <Grid item>
                  <Typography>※印刷時</Typography>
                  <Typography
                    style={countText(modalComment) > 30 ? { color: "red" } : {}}
                  >
                    1頁目の表示は全角30文字で切れます
                  </Typography>
                  <Typography>2～3頁目の表示は全角144文字で切れます</Typography>
                  <Typography>手書き入力した場合、印刷結果に理由等は表示されません</Typography>
                  <Typography>手書き入力で誤った内容で保存した場合はクリアボタンを押下することで新規に作成することができます</Typography>
                </Grid>
              </Grid>
            </Grid>
            {/*  その他コメントここまで↑*/}
          </Grid>
          {/*  ボタン↓ここから*/}
          <Grid container justify="center">
            <Grid item xs={6}>
              <Grid container justify="center">
                <Button
                  style={{ width: "30vw" }}
                  variant="contained"
                  fullWidth={true}
                  onClick={handleClose}
                  disabled={loading}
                >
                  キャンセル
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid container justify="center">
                {getFixedFlg() ? (
                  ""
                ) : (
                  <Button
                    style={{ width: "30vw" }}
                    variant="contained"
                    fullWidth={true}
                    onClick={(e) => handleSave(e)}
                    color="primary"
                    disabled={loading}
                  >
                    保存
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
          {/*  ボタン↑ここまで*/}
          {/* ダイアログ */}
          <TenpoCheckDialog
            msg={dialogMessage}
            isOpen={dialogFlg}
            doOK={dialogClose}
            doNo={dialogClose}
            isAlert={true}
          />
        </Grid>
      </Modal>
      {/*  モーダル↑ここまで*/}
    </>
  );
};
export default TenpoCheckModalButton;
